// extracted by mini-css-extract-plugin
export default {"form":"ReportPrompt_form__Ai2i1","actions":"ReportPrompt_actions__hBifs"};